module.exports = __webpack_public_path__ + "static/bgAsset-py-9d324d9cbb1e5f16eb5bfe3354f7597d.jpg";